import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import classes from "./styles.module.css";
import Api from "../../../Api";
import Loader from "../../Utils/Loader";
import Modal from "../../Utils/Modal";

function StatusPill(props) {
    var intl = useIntl();
    var status = props.status;
    var configMap = {
        0: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.created" }), bg: "#e3f2fd", color: "#1565c0" },
        1: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.antifraud" }), bg: "#ffebee", color: "#c62828" },
        2: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.rejected" }), bg: "#ffebee", color: "#c62828" },
        3: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.registry" }), bg: "#f3e5f5", color: "#7b1fa2" },
        5: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.success" }), bg: "#e8f5e9", color: "#2e7d32" },
        6: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.error" }), bg: "#fce4ec", color: "#ad1457" },
        7: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.awaitingPayout" }), bg: "#e1f5fe", color: "#0277bd" },
    };
    var config = configMap[status] || { label: "?" + status, bg: "#f5f5f5", color: "#666" };

    return (
        <span className={classes.StatusPill} style={{ background: config.bg, color: config.color }}>
            {config.label}
        </span>
    );
}

function formatDate(dateStr) {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

function formatAmount(amount, currency) {
    if (amount === null || amount === undefined) return "-";
    var value = Number(amount);
    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + (currency || "RUB");
}

function CrmPayoutDetails(props) {
    var intl = useIntl();
    var request = props.request;
    var token = props.token;
    var onUpdate = props.onUpdate;
    var onClose = props.onClose;
    var onRegistryClick = props.onRegistryClick;
    var onMessage = props.onMessage || function () {};

    var _declineReason = useState("");
    var declineReason = _declineReason[0];
    var setDeclineReason = _declineReason[1];

    var _showDeclineInput = useState(false);
    var showDeclineInput = _showDeclineInput[0];
    var setShowDeclineInput = _showDeclineInput[1];

    var _isLoading = useState(false);
    var isLoading = _isLoading[0];
    var setIsLoading = _isLoading[1];

    var _showAntifraud = useState(false);
    var showAntifraud = _showAntifraud[0];
    var setShowAntifraud = _showAntifraud[1];

    var _showSuccessInput = useState(false);
    var showSuccessInput = _showSuccessInput[0];
    var setShowSuccessInput = _showSuccessInput[1];

    var _successFee = useState("");
    var successFee = _successFee[0];
    var setSuccessFee = _successFee[1];

    // Сброс при переключении заявки
    useEffect(function () {
        setDeclineReason("");
        setShowDeclineInput(false);
        setShowAntifraud(false);
        setShowSuccessInput(false);
        setSuccessFee("");
    }, [request ? request.id : null]);

    if (!request) return null;

    var status = Number(request.status);

    // Контекстные действия по статусу
    var canSendToAntifraud = status === 0;
    var canDecline = status === 0 || status === 6 || status === 7;
    var canMoveBack = status === 3 || status === 6;
    var canMoveToSuccess = status === 3 || status === 4 || status === 6 || status === 7;
    var hasActions = canSendToAntifraud || canDecline || canMoveBack || canMoveToSuccess;

    // Отклонить заявку
    function handleDecline() {
        if (!declineReason) {
            onMessage({ type: "warning", message: intl.formatMessage({ id: "CrmPayoutDetails.error.declineReasonRequired" }) });
            return;
        }
        setIsLoading(true);
        var api = new Api({ token: token });
        api.declineCrmPayoutRequest(request.id, declineReason).then(function () {
            return api.getCrmPayoutRequest(request.id);
        }).then(function (updated) {
            onUpdate(updated);
            setShowDeclineInput(false);
            setDeclineReason("");
        }).catch(function (e) {
            var msg =
                (e.response && e.response.data && e.response.data.message) ||
                e.message ||
                intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
        }).then(function () {
            setIsLoading(false);
        });
    }

    // Отправить на антифрод
    function handleSendToAntifraud() {
        setIsLoading(true);
        var api = new Api({ token: token });
        api.sendToAntifraudCrmPayoutRequests([request.id]).then(function (result) {
            if (result.errors && result.errors.length > 0) {
                onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: result.errors[0].error }) });
            } else {
                onMessage({ type: "success", message: intl.formatMessage({ id: "CrmPayoutDetails.success.sentToAntifraud" }) });
            }
            return api.getCrmPayoutRequest(request.id);
        }).then(function (updated) {
            onUpdate(updated);
        }).catch(function (e) {
            var msg =
                (e.response && e.response.data && e.response.data.message) ||
                e.message ||
                intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
        }).then(function () {
            setIsLoading(false);
        });
    }

    // Перевести в успех
    function handleMoveToSuccess() {
        setIsLoading(true);
        var api = new Api({ token: token });
        var fee = successFee ? parseFloat(successFee) : null;
        api.moveToSuccessCrmPayoutRequest(request.id, fee).then(function () {
            return api.getCrmPayoutRequest(request.id);
        }).then(function (updated) {
            onUpdate(updated);
            setShowSuccessInput(false);
            setSuccessFee("");
            onMessage({ type: "success", message: intl.formatMessage({ id: "CrmPayoutDetails.success.movedToSuccess" }) });
        }).catch(function (e) {
            var msg =
                (e.response && e.response.data && e.response.data.message) ||
                e.message ||
                intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
        }).then(function () {
            setIsLoading(false);
        });
    }

    // Вернуть в ожидание
    function handleMoveBack() {
        setIsLoading(true);
        var api = new Api({ token: token });
        api.moveBackToAwaitingCrmPayoutRequests([request.id]).then(function () {
            return api.getCrmPayoutRequest(request.id);
        }).then(function (updated) {
            onUpdate(updated);
        }).catch(function (e) {
            var msg =
                (e.response && e.response.data && e.response.data.message) ||
                e.message ||
                intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
        }).then(function () {
            setIsLoading(false);
        });
    }

    var title = intl.formatMessage({ id: "CrmPayoutDetails.title" }, { id: request.id });

    return (
        <Modal isOpen={true} onClose={onClose} title={title}>
            <div className={classes.ModalBody}>
                {/* Статус */}
                <div className={classes.StatusRow}>
                    <StatusPill status={status} />
                </div>

                {/* Сумма */}
                <div className={classes.AmountBlock}>
                    <div className={classes.AmountValue}>
                        {formatAmount(request.amount, request.currency)}
                    </div>
                </div>

                {/* Информация — 2 колонки */}
                <div className={classes.InfoGrid}>
                    <div className={classes.InfoItem}>
                        <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.fullName" })}</span>
                        <span className={classes.InfoValue}>{request.fullName || "-"}</span>
                    </div>
                    <div className={classes.InfoItem}>
                        <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.merchant" })}</span>
                        <span className={classes.InfoValue}>{request.merchantName || "-"}</span>
                    </div>
                    <div className={classes.InfoItem}>
                        <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.createdAt" })}</span>
                        <span className={classes.InfoValue}>{formatDate(request.createdAt)}</span>
                    </div>

                    {request.payoutType === "sbp" ? (
                        <React.Fragment>
                            <div className={classes.InfoItem}>
                                <span className={classes.InfoLabel}>Телефон СБП</span>
                                <span className={classes.InfoValueMono}>{request.sbpPhone || "-"}</span>
                            </div>
                            <div className={classes.InfoItem}>
                                <span className={classes.InfoLabel}>Банк</span>
                                <span className={classes.InfoValue}>{request.sbpBankName || "-"}</span>
                            </div>
                            <div className={classes.InfoItem}>
                                <span className={classes.InfoLabel}>Код банка СБП</span>
                                <span className={classes.InfoValueMono}>{request.sbpBankCode || request.sbpBankBic || "-"}</span>
                            </div>
                        </React.Fragment>
                    ) : (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.card" })}</span>
                            <span className={classes.InfoValueMono}>{request.cardPanMasked || "-"}</span>
                        </div>
                    )}

                    {request.phone && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.phone" })}</span>
                            <span className={classes.InfoValue}>{request.phone}</span>
                        </div>
                    )}
                    {request.email && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.email" })}</span>
                            <span className={classes.InfoValue}>{request.email}</span>
                        </div>
                    )}

                    {/* ID транзакции */}
                    {request.transactionId && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.transaction" })}</span>
                            <span className={classes.InfoValueLink}>#{request.transactionId}</span>
                        </div>
                    )}

                    {/* ID реестра — кликабельный */}
                    {request.registryId && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.registry" })}</span>
                            <span
                                className={classes.InfoValueLink}
                                onClick={function () {
                                    if (onRegistryClick) onRegistryClick(request.registryId);
                                }}
                            >
                                #{request.registryId}
                            </span>
                        </div>
                    )}

                    {request.externalReference && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.documentNumber" })}</span>
                            <span className={classes.InfoValueMono}>{request.externalReference}</span>
                        </div>
                    )}
                    {request.documentDate && (
                        <div className={classes.InfoItem}>
                            <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.documentDate" })}</span>
                            <span className={classes.InfoValue}>{request.documentDate}</span>
                        </div>
                    )}
                    {request.description && (
                        <div className={classes.InfoItem + " " + classes.InfoItemFull}>
                        <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.description" })}</span>
                            <span className={classes.InfoValue}>{request.description}</span>
                        </div>
                    )}
                    {request.updatedAt && (
                        <div className={classes.InfoItem}>
                        <span className={classes.InfoLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.info.updatedAt" })}</span>
                            <span className={classes.InfoValue}>{formatDate(request.updatedAt)}</span>
                        </div>
                    )}
                </div>

                {/* Причина отклонения */}
                {request.declineReason && (
                    <div className={classes.DeclineBox}>
                        <div className={classes.DeclineLabel}>{intl.formatMessage({ id: "CrmPayoutDetails.decline.title" })}</div>
                        <div className={classes.DeclineText}>{request.declineReason}</div>
                    </div>
                )}

                {/* Антифрод — сворачиваемый */}
                {request.antifraudDetails && (
                    <div className={classes.AntifraudSection}>
                        <button
                            className={classes.AntifraudToggle}
                            onClick={function () { setShowAntifraud(!showAntifraud); }}
                            type="button"
                        >
                            {intl.formatMessage({ id: "CrmPayoutDetails.antifraud.toggle" })} {showAntifraud ? "\u25B2" : "\u25BC"}
                        </button>
                        {showAntifraud && (
                            <pre className={classes.AntifraudPre}>
                                {JSON.stringify(request.antifraudDetails, null, 2)}
                            </pre>
                        )}
                    </div>
                )}

                {/* Действия — контекстные по статусу */}
                {hasActions && (
                    <div className={classes.ActionsSection}>
                        {showDeclineInput && (
                            <div className={classes.DeclineInputWrap}>
                                <input
                                    className={classes.Input}
                                    placeholder={intl.formatMessage({ id: "CrmPayoutDetails.decline.placeholder" })}
                                    value={declineReason}
                                    onChange={function (e) { setDeclineReason(e.target.value); }}
                                />
                            </div>
                        )}

                        <div className={classes.ActionButtons}>
                            {canSendToAntifraud && (
                                <button
                                    className={classes.BtnPrimary}
                                    onClick={handleSendToAntifraud}
                                    disabled={isLoading}
                                >
                                    {isLoading ? <Loader isString /> : intl.formatMessage({ id: "CrmPayoutDetails.action.sendToAntifraud" })}
                                </button>
                            )}

                            {canMoveBack && (
                                <button
                                    className={classes.BtnWarning}
                                    onClick={handleMoveBack}
                                    disabled={isLoading}
                                >
                                    {isLoading ? <Loader isString /> : intl.formatMessage({ id: "CrmPayoutDetails.action.moveBack" })}
                                </button>
                            )}

                            {canMoveToSuccess && !showSuccessInput && (
                                    <button
                                        className={classes.BtnSuccess}
                                        onClick={function () { setShowSuccessInput(true); }}
                                        disabled={isLoading}
                                    >
                                        {intl.formatMessage({ id: "CrmPayoutDetails.action.moveToSuccess" })}
                                    </button>
                            )}

                            {canMoveToSuccess && showSuccessInput && (
                                <React.Fragment>
                                    <input
                                        className={classes.Input}
                                        type="number"
                                        step="0.01"
                                        placeholder={intl.formatMessage({ id: "CrmPayoutDetails.success.feePlaceholder" })}
                                        value={successFee}
                                        onChange={function (e) { setSuccessFee(e.target.value); }}
                                    />
                                    <button
                                        className={classes.BtnSuccess}
                                        onClick={handleMoveToSuccess}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? <Loader isString /> : intl.formatMessage({ id: "CrmPayoutDetails.action.confirm" })}
                                    </button>
                                    <button
                                        className={classes.BtnSecondary}
                                        onClick={function () { setShowSuccessInput(false); setSuccessFee(""); }}
                                    >
                                        {intl.formatMessage({ id: "CrmPayoutDetails.action.cancel" })}
                                    </button>
                                </React.Fragment>
                            )}

                            {canDecline && !showDeclineInput && (
                                <button
                                    className={classes.BtnDanger}
                                    onClick={function () { setShowDeclineInput(true); }}
                                    disabled={isLoading}
                                >
                                    {intl.formatMessage({ id: "CrmPayoutDetails.action.decline" })}
                                </button>
                            )}

                            {canDecline && showDeclineInput && (
                                <React.Fragment>
                                    <button
                                        className={classes.BtnDanger}
                                        onClick={handleDecline}
                                        disabled={isLoading || !declineReason}
                                    >
                                        {isLoading ? <Loader isString /> : intl.formatMessage({ id: "CrmPayoutDetails.action.confirmDecline" })}
                                    </button>
                                    <button
                                        className={classes.BtnSecondary}
                                        onClick={function () { setShowDeclineInput(false); setDeclineReason(""); }}
                                    >
                                        {intl.formatMessage({ id: "CrmPayoutDetails.action.cancel" })}
                                    </button>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}

CrmPayoutDetails.defaultProps = {
    onUpdate: function () {},
    onClose: function () {},
    onRegistryClick: function () {},
    onMessage: function () {},
};

export default CrmPayoutDetails;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmPayoutDetails/index.js